import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const COLLECTIONS = buildModuleApi({
    prefix: "NOTEBOOK_COLLECTIONS", uri: "notebook/collections", withExtra: false,
    exclude: ["ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    overrides: {
        LIST: { url: "/notebook/collections" }, CREATE: { url: "/notebook/collections" },
        UPDATE: { url: "/notebook/collections" }, REMOVE: { url: "/notebook/collections" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const ENTRIES = buildModuleApi({
    prefix: "NOTEBOOK_ENTRIES", uri: "notebook/entries", withExtra: false,
    exclude: ["ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    overrides: {
        LIST: { url: "/notebook/entries" }, CREATE: { url: "/notebook/entries" },
        UPDATE: { url: "/notebook/entries" }, REMOVE: { url: "/notebook/entries" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
        DUPLICATE: { suffix: "/:id/duplicate" },
    },
});

export const NOTEBOOK_COLLECTION_CONSTANTS = COLLECTIONS.CONSTANTS;
export const NOTEBOOK_ENTRY_CONSTANTS = ENTRIES.CONSTANTS;
export const NOTEBOOK_ENDPOINTS = { ...COLLECTIONS.ENDPOINTS, ...ENTRIES.ENDPOINTS };
